import { render } from "./ConnectorsComponent.vue?vue&type=template&id=50e45328&ts=true&lang=html"
import script from "./ConnectorsComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConnectorsComponent.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__